module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('module-configuration', {
    attrs: {
      "data": _vm.config,
      "errors": _vm.errors
    }
  }, [_c('div', {
    staticClass: "l-row",
    attrs: {
      "slot": "auth"
    },
    slot: "auth"
  }, [_c('form-group', {
    attrs: {
      "label": "Ambiente",
      "required": true
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.config.auth.environment),
      expression: "config.auth.environment"
    }],
    staticClass: "form-select",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.config.auth, "environment", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "sandbox"
    }
  }, [_vm._v("Sandbox")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "production"
    }
  }, [_vm._v("Produção")])])]), _vm._v(" "), _c('form-group', {
    attrs: {
      "label": "E-mail"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.config.auth.email),
      expression: "config.auth.email"
    }],
    staticClass: "form-input",
    domProps: {
      "value": (_vm.config.auth.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.config.auth, "email", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('form-group', {
    attrs: {
      "label": "Token"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.config.auth.token),
      expression: "config.auth.token"
    }],
    staticClass: "form-input",
    domProps: {
      "value": (_vm.config.auth.token)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.config.auth, "token", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('form-group', {
    attrs: {
      "label": "Código da loja"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.config.auth.storeCode),
      expression: "config.auth.storeCode"
    }],
    staticClass: "form-input",
    domProps: {
      "value": (_vm.config.auth.storeCode)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.config.auth, "storeCode", $event.target.value)
      }
    }
  })])], 1), _vm._v(" "), _c('panel', {
    attrs: {
      "title": "Produtos"
    }
  }, [_c('div', {
    staticClass: "l-row"
  }, [_c('product-price-configuration', {
    attrs: {
      "input": _vm.config.product.price
    }
  }), _vm._v(" "), _c('form-group', {
    attrs: {
      "label": "Redutor de estoque padrão"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.config.product.stock.reducer),
      expression: "config.product.stock.reducer"
    }],
    staticClass: "form-input",
    attrs: {
      "min": "0",
      "type": "number"
    },
    domProps: {
      "value": (_vm.config.product.stock.reducer)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.config.product.stock, "reducer", $event.target.value)
      }
    }
  })])], 1)]), _vm._v(" "), _c('panel', {
    attrs: {
      "title": _vm.$t('quotation.label')
    }
  }, [_c('div', {
    staticClass: "l-row"
  }, [_c('div', {
    staticClass: "l-col-6@md"
  }, [_c('quotation-configuration', {
    attrs: {
      "quotation": _vm.config.quotation,
      "marketplace": _vm.identifier
    }
  })], 1)])]), _vm._v(" "), _c('panel', {
    attrs: {
      "title": _vm.$t('expediter.label')
    }
  }, [_c('expediter-configuration', {
    attrs: {
      "expediter": _vm.config.order.expediter
    }
  })], 1), _vm._v(" "), _c('panel', {
    attrs: {
      "title": _vm.$t('order.label')
    }
  }, [_c('order-retrieve-date-configuration', {
    attrs: {
      "orderConfigs": _vm.config.order
    }
  })], 1), _vm._v(" "), ((this.shippingMethods && this.shippingMethods.length)) ? _c('panel', {
    attrs: {
      "title": "Transportadoras"
    }
  }, [_c('label', [_vm._v("Códigos")]), _vm._v(" "), _vm._l((this.shippingMethods), function(shippingMethod) {
    return _c('div', {
      staticClass: "l-row"
    }, [_c('form-group', [_c('label', [_vm._v(_vm._s(shippingMethod.name) + " - " + _vm._s(shippingMethod.identifier))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.config.shipping.methods[shippingMethod.identifier]),
        expression: "config.shipping.methods[shippingMethod.identifier]"
      }],
      staticClass: "form-input",
      domProps: {
        "value": (_vm.config.shipping.methods[shippingMethod.identifier])
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.config.shipping.methods, shippingMethod.identifier, $event.target.value)
        }
      }
    })])], 1)
  })], 2) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-69d7457c","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Configuration/Ramarim.vue
// module id = 3257
// module chunks = 0